import styled, { keyframes } from 'styled-components';

import { Z_INDEX } from '../../../config/ui/zIndex';

import { SEMANTIC_COLORS } from '../../../constant/unit/color';

/* reference of the loader code snippets: https://cssloaders.github.io/ */

const load = keyframes`
0%,
100% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 1), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.7), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.2), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.2), 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.2), 

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.2), 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  0em 2.5em 0 0em rgba(93, 134, 90, 0.2), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.4), 

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.5), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.6), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.7),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.8);
}
12.5% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.7), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.5), 

  1.8em -1.8em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER}, 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.7), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.2), 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.2), 

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.2), 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  0em 2.5em 0 0em rgba(93, 134, 90, 0.2), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.2),

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.4), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.5),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.6);
}
25% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.5), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.6), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.7), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.7), 

  2.5em 0em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER}, 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.2), 

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.2),
  1em 2.3em 0 0em rgba(93, 134, 90, 0.2),  

  0em 2.5em 0 0em rgba(93, 134, 90, 0.2), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.2),

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.4);
}
37.5% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.2), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.3), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.5), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.6), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.7), 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.8), 

  1.8em 1.75em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER}, 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.7), 

  0em 2.5em 0 0em rgba(93, 134, 90, 0.2), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.2),

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.2);
}
50% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.2), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.2), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.4), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.5), 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.6), 

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.7), 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.8), 

  0em 2.5em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER}, 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.7), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.2),

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.2);
}
62.5% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.2), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.2), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.2), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.2), 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.4), 

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.5), 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.6), 

  0em 2.5em 0 0em rgba(93, 134, 90, 0.7), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.8), 

  -1.8em 1.8em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER}, 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.7),

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.2), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.2), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.2);
}
75% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.2), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.2), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.2), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.2), 
  2.35em 1em 0 0em rgba(93, 134, 90, 0.2), 

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.2), 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.4), 

  0em 2.5em 0 0em rgba(93, 134, 90, 0.5), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.6), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.7),
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.8),

  -2.6em 0em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER}, 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.7), 

  -1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2),
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.2);
}
87.5% {
  box-shadow: 
  0em -2.6em 0em 0em rgba(93, 134, 90, 0.2), 
  1em -2.4em 0em 0em rgba(93, 134, 90, 0.2), 

  1.8em -1.8em 0 0em rgba(93, 134, 90, 0.2), 
  2.3em -1em 0 0em rgba(93, 134, 90, 0.2), 

  2.5em 0em 0 0em rgba(93, 134, 90, 0.2),
  2.35em 1em 0 0em rgba(93, 134, 90, 0.2),  

  1.8em 1.75em 0 0em rgba(93, 134, 90, 0.2), 
  1em 2.3em 0 0em rgba(93, 134, 90, 0.2), 

  0em 2.5em 0 0em rgba(93, 134, 90, 0.2), 
  -1em 2.3em 0 0em rgba(93, 134, 90, 0.4), 

  -1.8em 1.8em 0 0em rgba(93, 134, 90, 0.5), 
  -2.35em 1em 0 0em rgba(93, 134, 90, 0.6),

  -2.6em 0em 0 0em rgba(93, 134, 90, 0.7), 
  -2.35em -1em 0 0em rgba(93, 134, 90, 0.8), 

  -1.8em -1.8em 0 0em ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER},
  -1em -2.4em 0 0em rgba(93, 134, 90, 0.7);
}
`;

export const S = {
  Wrapper: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${Z_INDEX.LOADING};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
    opacity: 0.9;
  `,
  Loader: styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 0.24em;
    height: 0.24em;
    margin: 0 auto;

    font-size: 25px;
    border-radius: 50%;

    animation: ${load} 1s infinite ease;

    & > div {
      flex-shrink: 0;
      font-size: 20px;
      font-weight: 700;
      color: ${SEMANTIC_COLORS.DEFAULT_LOADING_SPINNER};
    }
  `,
};
